module.exports = __webpack_public_path__ + "IR.png?28848aca6fbbf48d7f015d86b124c61f";